import { Link, useLocation, useNavigate } from "react-router";

export function SmartBack({
  fallback,
  children = "Back",
}: {
  fallback: string;
  children?: string;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <button
      className="btn-ghost"
      type="button"
      onClick={() => {
        if (location.key === "default") navigate(fallback);
        else navigate(-1);
      }}
    >
      {children}
    </button>
  );
}

export function SmartClose({ fallback, children = "Close" }: { fallback: string; children?: string }) {
  return <SmartBack fallback={fallback}>{children}</SmartBack>;
}

export function DayNav({
  dates,
  current,
}: {
  dates: string[];
  current: string;
}) {
  const index = dates.indexOf(current);
  const prev = index > 0 ? dates[index - 1] : null;
  const next = index >= 0 && index < dates.length - 1 ? dates[index + 1] : null;
  return (
    <div className="day-nav">
      {prev ? <Link className="btn-secondary" to={`/journey/day/${prev}`}>Previous day</Link> : <span />}
      {next ? <Link className="btn-secondary" to={`/journey/day/${next}`}>Next day</Link> : <span />}
    </div>
  );
}
